<template>
  <div class="event-listing">
    <Filters
      :state="state"
      :refreshListing="refreshListing"
    />
    <div class="events">
      <Event
        v-for="(event, id) in state.events"
        :key="id"
        :eventObject="event"
        :state="state"
      />
      <p v-if="!state.events.length">Nie znaleziono żadnych wydarzeń.</p>
    </div>
    <div class="article-pager" v-if="state.amountEvents != 1">
      <nav class="pager" role="navigation" aria-labelledby="pagination-heading" style="display: flex">
          <ul class="pager__items js-pager__items">
            <li v-for="element in state.pager"
            :key="element.key"
            class="pager__item"
            @click.prevent=" element.value == '...' ? preventDefault() : changePage(element.key - 1); scrollToTop()"
            :class="[
              { 'is-active': element.key == (state.currentPage + 1) },
            ]"
            >
              {{ element.value }}
            </li>
          </ul>
      </nav>
    </div>
  </div>
</template>

<script>
import Event from './components/Event.vue'
import Filters from './components/Filters.vue'
import axios from 'axios'
import Vue from 'vue'
import { getFiltersFromUrl, addCurrentFiltersToUrl } from './utils'
Vue.prototype.drupalSettings = window.drupalSettings;
Vue.prototype.Drupal = window.Drupal;

export default {
  name: 'App',
  components: {
    Event,
    Filters
  },
  data() {
    const state = Vue.observable({
      Drupal: window.Drupal,
      filters: {},
      events: [],
      amountEvents: [],
      page: [],
      currentPage: [],
      dictionaries: {},
      pager: [],
      regionFilterShow: false,
      hasMore: false,
      changedFilters: true,
      enforcedFilters: {type:this.drupalSettings['scm_event']['event_listing_block']['type']},
      disabledFilters: this.drupalSettings['scm_event']['event_listing_block']['disabledFilters'],
      hideFilters: this.drupalSettings['scm_event']['event_listing_block']['hideFilters']
    })

    return { state }
  },
  methods: {
    async changePage(page) {
      const {data} = await axios.get('/api/v1/events', {
        params: {
          ...this.state.filters,
          page: page,
          enforcedFilters: this.state.enforcedFilters
        }
      })
      this.state.events = data.events
      this.state.currentPage = data.currentPage
      this.state.pager = this.calculatePager(data.amount, data.currentPage)
    },
    async getDictionaries() {
      let enforcedFilters = this.state.enforcedFilters
      let { data } = await axios.get('/api/v1/events/filters', {params: {enforcedFilters}})
      this.state.dictionaries = data
    },
    async refreshListing() {
      const limit = 5
      let offset = this.state.events.length
      if (this.state.changedFilters) {
        offset = 0
        this.state.changedFilters = false
      }
      let enforcedFilters = this.state.enforcedFilters
      const { data } = await axios.get('/api/v1/events', {
        params: {
          ...this.state.filters,
          limit,
          offset,
          enforcedFilters
        }
      })
      this.state.amountEvents = data.amount
      this.state.currentPage = data.currentPage
      this.state.hasMore = data.length >= limit
      this.state.pager = this.calculatePager(data.amount, data.currentPage)
      addCurrentFiltersToUrl(this.state.filters)
      this.state.events = data.events
      
      let regions = await axios.get('/api/v1/events/regions')
      this.state.regionFilterShow = regions.data.region_filter_show

    },
    scrollToTop() {
      window.scrollTo({
        top: 200,
        behavior: 'smooth'
      });
    },
    calculatePager(amount, current) {
      let obj = [];
      const start = current;
      const stop = current == 0 ? current + 4 : current + 3;
      let range = this.rangeCalculate(start, stop);
      range = range.filter(function(x){ return x > 0 });

      for (let i = 1; i <= amount; i++) {
        if (amount <= 3) {
          obj.push({ key: i, value: i });
        } else {
          let middle = Math.ceil(amount / 2);
          if (range.includes(i)) {
            obj.push({ key: i, value: i });
          }
          if (i == 1 && (current + 1 > middle || range[0] > 1)) {
            obj.push({ key: i, value: "Pierwsza" });
            obj.push({ key: i + 0.5, value: "..." });
          }
          if (
            i == amount &&
            (current + 1 <= middle || range[range.length - 1] < amount)
          ) {
            obj.push({ key: i - 0.5, value: "..." });
            obj.push({ key: i, value: "Ostatnia" });
          }
        }
      }
      return obj;
    },
    rangeCalculate(start, stop) {
      const step = 1;
      return Array(Math.ceil((stop - start) / step)).fill(start).map((x, y) => x + y * step)
    }
  },
  created() {
    this.getDictionaries()
    this.state.filters = getFiltersFromUrl()
    this.refreshListing()
    this.scrollToTop()
  }
}

</script>
